import React, { useState } from 'react';
import { ChevronDown, Check } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
import { FadeIn } from './ui/FadeIn';
export function QueIncluye() {
  const tomos = [{
    num: 1,
    title: 'Técnica esencial: los golpes que ganan puntos',
    desc: 'Dominá los golpes básicos y avanzados con la técnica correcta.',
    extra: 'Aprendé empuñadura, golpe de derecha, revés, volea y bandeja con progresiones simples y aplicables desde el primer día.',
    price: '$6.990'
  }, {
    num: 2,
    title: 'El juego en la red: dominá la delantera',
    desc: 'Aprendé dónde pararte para dominar la red y el fondo.',
    extra: 'Mapas de cobertura, cuándo subir a la red y cómo defender el fondo para no dejar huecos en la cancha.',
    price: '$6.990'
  }, {
    num: 3,
    title: 'Posicionamiento y movimiento en cancha',
    desc: 'Sincronizate con tu compañero como los profesionales.',
    extra: 'Comunicación, señas, quién va a cada pelota y jugadas armadas para ganar más puntos en pareja.',
    price: '$5.990'
  }, {
    num: 4,
    title: 'Estrategia de dobles: ganar como equipo',
    desc: 'Identificá y eliminá los vicios que te cuestan partidos.',
    extra: 'Los 15 errores más comunes del jugador amateur y cómo corregirlos con ejercicios concretos.',
    price: '$5.990'
  }, {
    num: 5,
    title: 'Los 30 errores más comunes del jugador amateur',
    desc: 'Rutinas específicas para mejorar tu físico en la cancha.',
    extra: 'Rutinas de fuerza, resistencia y coordinación pensadas para tu nivel y tu tiempo disponible.',
    price: '$4.990'
  }, {
    num: 6,
    title: 'Plan de mejora de 30 días: de amateur a competitivo',
    desc: 'Mantené la calma y cerrá los partidos importantes.',
    extra: 'Manejo de la presión, foco punto a punto y cómo no regalar partidos que tenías ganados.',
    price: '$4.040'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="py-14 bg-padel-dark relative border-t border-white/5" data-id="element-208">
      <div className="container mx-auto px-4 max-w-5xl" data-id="element-209">
        {/* Stats card */}
        <FadeIn data-id="element-210">
          <div className="bg-padel-blue border border-neon/20 rounded-3xl p-8 mb-10 relative overflow-hidden shadow-[0_0_40px_rgba(198,255,0,0.06)]" data-id="element-211">
            <div className="absolute -top-10 -right-10 w-40 h-40 bg-neon/10 blur-3xl rounded-full pointer-events-none" data-id="element-212"></div>

            {/* Badge */}
            <div className="flex justify-center mb-6 relative z-10" data-id="element-213">
              <span className="inline-flex items-center gap-1.5 bg-white/5 border border-neon/30 text-neon font-display font-bold text-xs md:text-sm uppercase tracking-widest px-4 py-1.5 rounded-full" data-id="element-214">
                <Check className="w-4 h-4" data-id="element-215" /> Sistema N°1 para amateurs
              </span>
            </div>

            {/* Stats */}
            <div className="flex items-center justify-center divide-x divide-white/10 mb-6 relative z-10" data-id="element-216">
              <div className="px-6 md:px-8 text-center" data-id="element-217">
                <div className="font-display font-bold text-4xl md:text-5xl text-neon" data-id="element-218">
                  +150
                </div>
                <div className="text-gray-400 text-[11px] md:text-xs tracking-widest mt-1" data-id="element-219">
                  EJERCICIOS
                </div>
              </div>
              <div className="px-6 md:px-8 text-center" data-id="element-220">
                <div className="font-display font-bold text-4xl md:text-5xl text-neon" data-id="element-221">
                  6
                </div>
                <div className="text-gray-400 text-[11px] md:text-xs tracking-widest mt-1" data-id="element-222">
                  TOMOS
                </div>
              </div>
              <div className="px-6 md:px-8 text-center" data-id="element-223">
                <div className="font-display font-bold text-4xl md:text-5xl text-neon" data-id="element-224">
                  30
                </div>
                <div className="text-gray-400 text-[11px] md:text-xs tracking-widest mt-1" data-id="element-225">
                  DÍAS DE PLAN
                </div>
              </div>
            </div>

            {/* Keywords */}
            <p className="text-center font-display font-bold text-base md:text-lg mb-5 relative z-10" data-id="element-226">
              Técnica · Táctica · Dobles · Posicionamiento · Mentalidad · Físico
            </p>

            {/* Feature pills */}
            <div className="flex flex-wrap justify-center gap-2 relative z-10" data-id="element-227">
              {['Rutinas guiadas', 'Ejercicios paso a paso', 'Diagnóstico de errores', 'Plan de 30 días', 'Para principiantes', 'Nivel intermedio', 'Desde el celular', 'Acceso de por vida'].map(pill => <span key={pill} className="bg-white/5 border border-white/10 text-gray-200 text-xs md:text-sm px-3 py-1.5 rounded-full" data-id="element-228">
                  {pill}
                </span>)}
            </div>
          </div>
        </FadeIn>

        <FadeIn data-id="element-229">
          <h2 className="font-display text-3xl md:text-4xl font-bold text-center mb-2 uppercase" data-id="element-230">
            ¿Qué incluye el <span className="text-neon" data-id="element-231">Pack?</span>
          </h2>
          <p className="text-center text-gray-400 mb-10" data-id="element-232">
            Valor total <span className="line-through" data-id="element-233">$34.990</span> —{' '}
            <span className="text-neon font-bold" data-id="element-234">hoy por $19.990</span>
          </p>
        </FadeIn>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-3" data-id="element-235">
          {tomos.map((tomo, idx) => {
          const isOpen = openIndex === idx;
          return <FadeIn key={idx} delay={idx * 0.06} data-id="element-236">
                <div className="bg-padel-blue rounded-lg p-4 border-l-4 border-neon relative overflow-hidden h-full flex flex-col shadow-md hover:shadow-neon/20 transition-shadow" data-id="element-237">
                  {/* Decorative background number */}
                  <div className="absolute -right-2 -bottom-5 font-display text-6xl font-bold text-white/5 pointer-events-none" data-id="element-238">
                    {tomo.num}
                  </div>

                  <div className="flex items-center justify-between mb-1 relative z-10" data-id="element-239">
                    <span className="text-neon font-display font-bold text-sm tracking-widest" data-id="element-240">
                      TOMO {tomo.num}
                    </span>
                    <span className="text-gray-300 font-display font-bold text-sm" data-id="element-241">
                      {tomo.price}
                    </span>
                  </div>
                  <h3 className="text-base font-bold mb-1 leading-tight relative z-10" data-id="element-242">
                    {tomo.title}
                  </h3>
                  <p className="text-gray-400 text-xs relative z-10" data-id="element-243">
                    {tomo.desc}
                  </p>

                  <AnimatePresence data-id="element-244">
                    {isOpen && <motion.div initial={{
                  height: 0,
                  opacity: 0
                }} animate={{
                  height: 'auto',
                  opacity: 1
                }} exit={{
                  height: 0,
                  opacity: 0
                }} transition={{
                  duration: 0.3
                }} className="overflow-hidden" data-id="element-245">
                        <p className="text-gray-300 text-xs mt-2 pt-2 border-t border-white/10 relative z-10" data-id="element-246">
                          {tomo.extra}
                        </p>
                      </motion.div>}
                  </AnimatePresence>

                  <button onClick={() => setOpenIndex(isOpen ? null : idx)} aria-expanded={isOpen} aria-label={isOpen ? `Ocultar detalle de ${tomo.title}` : `Ver más sobre ${tomo.title}`} className="mt-2 self-start flex items-center gap-1 text-neon text-xs font-bold uppercase tracking-wide relative z-10 focus:outline-none focus:ring-2 focus:ring-neon rounded" data-id="element-247">
                    {isOpen ? 'Ver menos' : 'Ver más'}
                    <ChevronDown className={`w-3.5 h-3.5 transition-transform duration-300 ${isOpen ? 'rotate-180' : ''}`} data-id="element-248" />
                  </button>
                </div>
              </FadeIn>;
        })}
        </div>
      </div>
    </section>;
}